const apiBase = '/api/v1/bj';
export const environment = {
  apiBusqueda: apiBase,
  apiBusquedaInt: apiBase + '/int',
  apiDocumento: apiBase,
  apiDocumentoInt: apiBase + '/int',
  apiDocSugeridos: apiBase,
  apiDocSugeridosInt: apiBase + '/int',
  apiReforma: apiBase,
  apiReformaInt: apiBase + '/int',
  apiArchivos: apiBase + '/storage',
  apiArchivosInt: apiBase + '/int/storage',
  apiRedconocimiento: apiBase + '/red/buscar',
  urlFiles: 'https://mxscjnbiblio.scjn.pjf.gob.mx/',
  urlFilesExt: 'https://www2.scjn.gob.mx/',
  urlLegislacion: 'https://legislacion.scjn.gob.mx/',
  apiAutocompletInt: apiBase,
  apiDatosAbiertos: apiBase + '/estadisticos',
  apiEstadisticos: apiBase,
  environmentType: apiBase + 'Int',

  keycloak: {
    realm: 'ia',
    clientId: 'bj-front',
    url: 'https://accounts.kube.scjn.pjf.gob.mx',
  },

  //INDICES
  sentencias: 'sentencias',
  profile: 'prod'
};
